import type { IResponsibilityUrlProps } from '@/modules/tasks/types/IResponsibilityListItem'
import { useFeedbackStore } from '@/modules/feedback/stores/feedbackStore'
import type { TNotificationMessageType } from '../types/notification.types'
import router from '@/router'

/**
 * Открывает глобальные модальные диалоги или выполняет роутинг по типизированным `urlProps`.
 *
 * @param props Свойства перехода сущности (eventId, ticketId, reportId, suggestionId, entryId, appealId, equipmentId, signatureCaseId)
 * @param openParentTaskTab Открывать ли в форме панель задач (сигнал globalFormTab = 2)
 * @returns true, если переход на сущность был успешно обработан
 */
export function openEntityByUrlProps(
  props: IResponsibilityUrlProps | null | undefined,
  openParentTaskTab = false,
): boolean {
  if (!props) return false
  const feedbackStore = useFeedbackStore()

  if (props.equipmentId && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(props.equipmentId)) {
    router.push({ path: `/equipment/${props.equipmentId}`, query: { tab: 'works' } })
    return true
  }

  if (props.signatureCaseId) {
    void router.push({ name: 'ELECTRONIC_SIGNATURE_CASE', params: { id: props.signatureCaseId } })
    return true
  }

  if (props.eventId) {
    if (openParentTaskTab) feedbackStore.globalFormTab = 2
    feedbackStore.globalAdverseEventId = props.eventId
    feedbackStore.createOrUpdateAdverseEvent = true
    return true
  }

  if (props.ticketId) {
    if (openParentTaskTab) feedbackStore.globalFormTab = 2
    feedbackStore.globalTicketId = props.ticketId
    return true
  }

  if (props.suggestionId) {
    if (openParentTaskTab) feedbackStore.globalFormTab = 2
    feedbackStore.globalImprovementId = props.suggestionId
    return true
  }

  if (props.reportId) {
    feedbackStore.globalAuditNonconformityReportId = props.reportId
    feedbackStore.globalAuditNonconformityAuditId = props.auditId ?? null
    return true
  }

  if (props.entryId) {
    feedbackStore.globalResponsibilityEntryId = props.entryId
    return true
  }

  if (props.appealId) {
    if (openParentTaskTab) feedbackStore.globalFormTab = 2
    feedbackStore.globalCitizenInquiryId = String(props.appealId)
    return true
  }

  return false
}

/**
 * Перехватывает клик по уведомлению для открытия глобальных модальных диалогов на текущей странице.
 *
 * Использует типизированные `urlProps` (eventId, ticketId, reportId, suggestionId, entryId).
 */
export function handleNotificationUrl(notification: {
  sourceType?: string | null
  urlProps?: IResponsibilityUrlProps | null
  messageType?: TNotificationMessageType
}): boolean {
  return openEntityByUrlProps(
    notification.urlProps,
    notification.messageType === 'responsibility_entry',
  )
}
